export const container3d = "crw2uh1";
export const container = "c5eb4nr";
export const layers = "l9s4k53";
export const layer = "lr8b9y6";
export const first = "f2rti3z";

require("./styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");